import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";

import { List } from "antd";
import services from "../../../../services";
import imgLogin from "../../../../assets/iconsMenu/img.svg";
import "./styles.scss";

const ListLoginImage = ({ showLoginImage }) => {
  const { IdUser, login, IsAdmin } = services.storage.getUser();
  const [loginImageSelecionado, setLoginImageSelecionado] = useState("");

  // Dados simulados - quando o endpoint estiver disponível, isso virá da API
  const loginImageData = {
    id: 1,
    titulo: "Imagem Tela de Login"
  };

  return (
    <div>
      <List
        className="list-permissoes mt-4"
        size="small"
        header={<b className="list-header">IMAGEM TELA DE LOGIN</b>}
        dataSource={[loginImageData]}
        renderItem={(item) => {
          return (
            <List.Item
              className="list-item listaNotificacao"
              style={{ cursor: "pointer" }}
              onClick={() => {
                showLoginImage(item.id);
                setLoginImageSelecionado(item.id);
              }}
            >
              <div>
                <span
                  onClick={() => {
                    showLoginImage(item.id);
                  }}
                >
                  <img width={30} src={imgLogin} className="mr-4" />
                  {item.titulo}
                </span>
              </div>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default ListLoginImage;

